<template>
    <div>
      <input v-bind:type="inputType" v-model="inputVal" v-bind:placeholder="placeholderText" class="input--override"/>
    </div>
</template>

<script>
  export default {
    name: 'SbInput',
    props: {
      inputType: {
        type: String,
        default: 'text'
      },
      inputValue: {
        required: true
      },
      valueKey: {
        type: String,
        default: 'value'
      },
      placeholderText: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        inputVal: null
      }
    },
    mounted () {
      this.inputVal = this.isObject ? this.inputValue[this.valueKey] : this.inputValue
    },
    watch: {
      inputVal (nv, ov) {
        if (nv === ov) return
        const normalizedValue = this.mapDataType(nv)
        let updatedValue = normalizedValue
        if (this.isObject) {
          updatedValue = Object.assign({}, this.inputValue)
          updatedValue[this.valueKey] = normalizedValue
        }
        this.$emit('update:value', updatedValue)
        this.$emit('updateValue', updatedValue)
      }
    },
    computed: {
      isObject () {
        return typeof this.inputValue === 'object'
      }
    },
    methods: {
      mapDataType (value) {
        let v = value
        if (this.inputType === 'number') {
          // TODOJB: if we have to handle floats, will have to refactor this.
          const normalized = parseInt(v)
          v = isNaN(normalized) ? 0 : normalized
        }
        return v
      }
    }
  }
</script>

<style scoped lang="scss">
  .input--override {
    border: none;
    border:solid 1px grey;
    border-radius: 3px;
    padding: 0.25rem;
    height: 2.5rem;
    outline: none;
  }
</style>
